import React from "react";
import { Input, Label } from "reactstrap";

function InputField(props) {
  const { formik } = props;
  return (
    <>
      <Label>{props?.placeholder}</Label>
      <Input
        id={props?.name}
        name={props?.name}
        placeholder={props?.placeholder}
        type={props?.type}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={props?.value}
        autoComplete="off"
        accept={
          props?.name === "secretFile" ? ".txt, .pem,.ppk" : null
        }
        rows={props?.rows}
      />
      {props?.touch && props?.error ? (
        <Label style={{ color: "red" }}>{props?.error}</Label>
      ) : null}
    </>
  );
}

export default InputField;
